var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ fileCol: !_vm.noName }},[(!_vm.noName)?_c('a',{staticClass:"fileName",on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.file ? _vm.file.name : ''))]):_vm._e(),_c('FileViewer',{ref:"fileViewer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }